module.exports = __webpack_public_path__ + "img/ico-grade-diamond.aea7ad1c.svg";